<div class="options-cancelled-orders">
	<app-table
		[statesColumns]="statesColumns()"
		[settings]="{
			size: 'md',
			spreadContent: 'space-between',
			rowBorder: true,
			emptyTextPath: 'optionsOrders.empty',
		}"
		[items]="ordersResponse()?.orders ?? []"
		[isLoading]="isLoading()"
	>
		<app-table-column
			[settings]="{
				titlePath: 'optionsOrders.tickerCompany',
				column: columnsOptionsCanceledOrdersEnum.tickerCompany,
				minWidthPx: 200,
				maxWidthPx: 230,
			}"
		>
			<ng-template let-item="item">
				<div class="ticker-column">
					<span class="text">{{ item?.option_ticker }}</span>
					<span class="text">{{ item?.option_strike | price }}</span>
					<span
						class="text"
						highlight
						[isPositive]="item?.option_type === optionTypeEnum.CALL"
						[isNegative]="item?.option_type === optionTypeEnum.PUT"
					>
						{{ item?.option_type | uppercase }}
					</span>
					<span class="text">{{ item?.option_date | date: 'dd.MM.yyyy' }}</span>
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'optionsOrders.operation',
				column: columnsOptionsCanceledOrdersEnum.operation,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					class="text"
					highlight
					[isPositive]="item.side === orderSideEnum.BUY"
					[isNegative]="item.side === orderSideEnum.SELL"
				>
					{{ 'optionsOrders.side.' + item.side | translate }}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'optionsOrders.quantity',
				column: columnsOptionsCanceledOrdersEnum.quantity,
				minWidthPx: 80,
				maxWidthPx: 100,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					secret
					[isSecret]="isSecret()"
					[secretCount]="4"
					class="text"
					>{{ item.qty | quantity }}</span
				>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'optionsOrders.price',
				column: columnsOptionsCanceledOrdersEnum.price,
				minWidthPx: 60,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<div class="prices">
					@if (item?.type === orderTypeEnum.LIMIT) {
						<span
							secret
							[isSecret]="isSecret()"
							[secretCount]="4"
							class="text"
							>{{ item?.limit_price | price }}</span
						>
					}
					@if (item?.type === orderTypeEnum.MARKET) {
						<span
							secret
							[isSecret]="isSecret()"
							[secretCount]="4"
							class="text"
							>-</span
						>
					}
				</div>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'optionsOrders.term',
				column: columnsOptionsCanceledOrdersEnum.term,
				minWidthPx: 60,
				maxWidthPx: 90,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span class="text">
					{{
						'optionsOrders.terms.' + (item.time_in_force | titleOrderTerm: !!item.extended_hours)
							| translate
					}}
				</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'optionsOrders.orderType',
				column: columnsOptionsCanceledOrdersEnum.orderType,
				minWidthPx: 90,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span class="text">{{ 'optionsOrders.types.' + item.type | translate }}</span>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'optionsOrders.executed',
				column: columnsOptionsCanceledOrdersEnum.executed,
				minWidthPx: 80,
				maxWidthPx: 100,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				<span
					secret
					[isSecret]="isSecret()"
					[secretCount]="4"
					class="text"
					>{{ item.filled_qty | quantity }}</span
				>
			</ng-template>
		</app-table-column>

		<app-table-column
			[settings]="{
				titlePath: 'optionsOrders.statusTitle',
				column: columnsOptionsCanceledOrdersEnum.statusTitle,
				minWidthPx: 100,
				maxWidthPx: 120,
				spreadContent: 'flex-end',
			}"
		>
			<ng-template let-item="item">
				@if (item.status === orderStatusEnum.HELD) {
					<tui-badge
						class="badge"
						tuiBadge
						size="m"
						appearance="neutral"
					>
						{{ 'optionsOrders.status.' + item?.status | translate }}
					</tui-badge>
				} @else if (item.status === orderStatusEnum.CANCELED) {
					<tui-badge
						class="badge"
						tuiBadge
						size="m"
						appearance="negative"
					>
						{{ 'optionsOrders.status.' + item.status | translate }}
					</tui-badge>
				} @else {
					<tui-badge
						class="badge"
						tuiBadge
						size="m"
						appearance="positive"
					>
						{{ 'optionsOrders.status.' + item.status | translate }}
					</tui-badge>
				}
			</ng-template>
		</app-table-column>

		<app-table-actions>
			<ng-template let-item="item">
				<app-options-canceled-orders-actions [option]="item" />
			</ng-template>
		</app-table-actions>

		<app-table-footer>
			<ng-template>
				<div class="footer">
					<div class="total">
						<span class="title">{{ 'optionsOrders.total' | translate }}:</span>
						<span
							class="value"
							[tuiSkeleton]="isLoading()"
							>{{ (ordersResponse()?.orders ?? []).length | quantity }}</span
						>
					</div>

					<app-pagination
						[isLoading]="isLoading()"
						[total]="ordersResponse()?.count ?? 0"
						[pageIndex]="ordersParams()?.page ?? 1"
						(pageChange)="onChangePage($event)"
					/>
				</div>
			</ng-template>
		</app-table-footer>
	</app-table>
</div>
